// extracted by mini-css-extract-plugin
var _1 = "DvvH4w9Iw0";
var _2 = "KXlTZzgn5a";
export { _1 as "arrow", _2 as "root" }
